
const tables = [
  {
    name: "Vendor",
  },
  {
    name: "Contact",
  },
  {
    name: "Total Payable",
  },
  {
    name: "0-30 Days",
  },
  {
    name: "31-60 Days",
  },
  {
    name: "61-90 Days",
  },
  {
    name: "90+ Days",
  },
  {
    name: "Discount",
  },
  {
    name: "Terms",
  },
  {
    name: "Due Date",
  },
 /*  {
    name: "Status",
  },
  {
    name: "Action",
  }, */
];

export default tables;